var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{class:_vm.classes},[_c('v-progress-circular',{attrs:{"indeterminate":"","rotate":360,"size":_vm.height,"width":10,"color":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }